import { OverLayFields } from '../models/OverlayFields';
import { PositioningType } from '../models/PositioningType';

export const HydraulicStrokingUnitPositioning: PositioningType[] = [
  {
    overlayField: OverLayFields.LastGoodScan,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ApiDesignation,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ControllerType,
    position: { x: 75, y: 156 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StrokeLength,
    position: { x: 75, y: 194 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StructuralLoading,
    position: { x: 75, y: 232 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StrokesPerMinute,
    position: { x: 75, y: 270 },
    justification: 'left',
  },
  { overlayField: OverLayFields.Protocol, position: { x: 75, y: 308 }, justification: 'left' },
  { overlayField: OverLayFields.HostName, position: { x: 75, y: 348 }, justification: 'left' },
  { overlayField: OverLayFields.Port, position: { x: 75, y: 387 }, justification: 'left' },
  { overlayField: OverLayFields.RTUAddress, position: { x: 75, y: 425 }, justification: 'left' },
  { overlayField: OverLayFields.Offset, position: { x: 75, y: 463 }, justification: 'left' },
  { overlayField: OverLayFields.OPCType, position: { x: 75, y: 501 }, justification: 'left' },
  {
    overlayField: OverLayFields.RunStatus,
    position: { x: 289, y: 306 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TimeInState,
    position: { x: 289, y: 337 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RodStrings,
    position: { x: 288, y: 625 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpingUnit,
    position: { x: 637, y: 156 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.MotorType,
    position: { x: 637, y: 194 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.MotorLoading,
    position: { x: 637, y: 232 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TubingPressure,
    position: { x: 637, y: 270 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.FlowlinePressure,
    position: { x: 637, y: 308 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.CasingPressure,
    position: { x: 637, y: 348 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpDepth,
    position: { x: 637, y: 573 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpType,
    position: { x: 637, y: 611 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpFillage,
    position: { x: 637, y: 649 },
    justification: 'left',
  },
];
